import { Injectable } from "@angular/core";
import { HttpParams } from '@angular/common/http';
import { environment } from "../../environments/environment";
import { HttpService } from '../shared/services/http.service';
import { HelperService } from '../shared/services/helper.service';
import { ReportActivationModel } from '../models/report.model';


@Injectable()
export class ReportService {

  private PARAMETER_ENDPOINT: string = '/giftCardVirtual';
  private BASE_URL: string = HelperService.buildRequestURL(environment.RipleyGiftCardVirtualApiEndPoint);
  private REQUEST_URL: string = `${this.BASE_URL}${this.PARAMETER_ENDPOINT}`;
  private URL: string;

  constructor(private httpService: HttpService) { }

  public GetReporteActivation(params){
    this.URL = `${this.REQUEST_URL}/getReporteActivation`;
    return this.httpService.post<ReportActivationModel[]>(this.URL, params);
  }

  public GetReporteSaldos(params){
      this.URL = `${this.REQUEST_URL}/getReporteSaldos`;
      return this.httpService.post<ReportActivationModel[]>(this.URL, params);
  }
}
